import { ChatIcon } from '../Icons'
import { Button } from '../ui/button'

interface ChatIconWithCountProps {
  count: number
  handleClick?: () => void
}

export default function ChatIconWithCount({
  count,
  handleClick,
}: Readonly<ChatIconWithCountProps>) {
  return (
    <div className="fixed bottom-8 right-5 z-[99]">
      <Button
        onClick={handleClick}
        className="relative flex items-center justify-center size-8 lg:size-10 bg-ss-blue-500 hover:bg-ss-blue-600 rounded-full"
        aria-label="Open Message Admin"
      >
        <ChatIcon className="size-4 lg:size-5 text-white" aria-hidden="true" />
        {count > 0 && (
          <span
            className="absolute -top-1 -right-1 flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-semibold text-white bg-red-500 rounded-full border-2 border-white"
            aria-label={`${count} unread messages`}
          >
            {count > 99 ? '99+' : count}
          </span>
        )}
      </Button>
    </div>
  )
}
